import { AxiosResponse } from "axios";
import { StipendDto } from "../../Model/Dto/WSP/MerSETASDE";
import { axiosWSPInstance } from "../AxiosWSPInterceptor";
import * as ApiUrls from "./ApiUrl.MersetaExternalAttendees";

export const StipendService = {
    GetStipendsForAttendee: (platformPeopleId: string, merSETAId: number): Promise<AxiosResponse<StipendDto[]>> => axiosWSPInstance.get(`${ApiUrls.attendee}/${platformPeopleId}/Stipend/${merSETAId}`),
    SaveStipends: (request: StipendDto[], platformPeopleId: string, merSETAId: number): Promise<AxiosResponse> => axiosWSPInstance.post(`${ApiUrls.attendee}/${platformPeopleId}/Stipend/${merSETAId}`, request)
}